import React from 'react';
import { Row, Col} from 'react-bootstrap';

const Plan = ({info}) => {
    return ( 
        <div>
            <p className='title-container-shadow' style={{marginBottom:16}}>Plan information</p>
            <div className='Data'>
                <Row>
                        <Col lg={4} md={6} sm={12} >
                        <p>Plan Name:</p>
                        <p>{info.name}</p>
                    </Col>
                        <Col lg={4} md={6} sm={12} >
                        <p>Name:</p>
                        <p>{}</p>
                    </Col>
                        <Col lg={4} md={6} sm={12} >
                        <p>Country:</p>
                        <p>{ }</p>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
 
export default Plan;